<div class="errorContainer">
    <p class="textStyling ps">{{errorMsg}}</p>
</div>

